import useGetUserProfile from "@/hooks/useGetUserProfile";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import AssistantLogo from "./AssistantLogo";

const AssistantEmptyState = () => {
    const { t } = useTranslation();
    const { data: user } = useGetUserProfile();
    const firstName = user?.firstName?.trim();

    return (
        <div className="flex w-full animate-opacity flex-col items-center px-5 text-center">
            <AssistantLogo size="lg" />
            <p className="mt-6 text-base text-assistant-muted">
                {firstName
                    ? t("vistassistant.emptyState.greeting", {
                          name: firstName,
                      })
                    : t("vistassistant.emptyState.greetingAnonymous")}
            </p>
            <h1 className="mt-4 text-balance font-display text-[34px] font-bold leading-tight text-primary-darkest md:text-[42px]">
                {t("vistassistant.emptyState.title")}
            </h1>
            <p className="mt-4 max-w-[520px] text-balance text-base text-assistant-muted">
                {t("vistassistant.emptyState.subtitle")}
            </p>
            <p className="mt-5 flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold leading-5 text-primary-darkest">
                <Check
                    aria-hidden
                    className="size-4 flex-none text-primary-dark"
                    strokeWidth={1.75}
                />
                {t("vistassistant.emptyState.consent")}
            </p>
        </div>
    );
};

export default AssistantEmptyState;
